import { Directive, Input, OnChanges, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[appAuthLicense]',
  exportAs: 'appAuthLicense',
})
export class AuthLicenseDirective implements OnChanges {
  /** 權力的類型，需帶入選項的標籤名稱 */
  @Input('appAuthLicense') authType: string;
  /** 權力圖示 url */
  image: string;
  /** 描述 */
  description: string;
  /** 權力說明連結 */
  url: string;
  /** 圖片寬度(px) */
  imageWidth: number;
  /** 圖片高度(px) */
  imageHeight: number;

  constructor() { }

  ngOnChanges(changes: SimpleChanges) {
    if (this.authType) {
      const f = transformAuthLicense(this.authType);
      if (f) {
        this.image = f.image;
        this.description = f.label;
        this.url = f.url;
        this.imageWidth = f.imageWidth;
        this.imageHeight = f.imageHeight;
      }
    }
  }
}

/** 參考網址 https://memory.culture.tw/Home/Authorization */
const auths = [
  {label: '公眾領域標章(PDM)', value: 'PDM', url: 'http://creativecommons.tw/pdm', image: '/assets/images/authority/publicdomain.large-25x25.webp', imageWidth: 25, imageHeight: 25},
  {label: '公眾領域貢獻宣告(CC0)', value: 'CC0', url: 'http://creativecommons.tw/cc0', image: '/assets/images/authority/CCzero.large-25x25.webp', imageWidth: 25, imageHeight: 25},
  {label: '政府資料開放授權條款-第1版(OGDL 1.0)', value: 'OGDL', url: 'https://data.gov.tw/license', image: '/assets/images/authority/cc_icon9.webp', imageWidth: 28, imageHeight: 35},
  {label: '創用CC姓名標示 3.0 台灣及其後版本(CC BY 3.0 TW +)', value: 'CC BY', url: 'https://creativecommons.org/licenses/by/3.0/tw/legalcode', image: '/assets/images/authority/cc-by-70x25.webp', imageWidth: 70, imageHeight: 25},
  {label: '創用CC姓名標示-相同方式分享 3.0 台灣及其後版本(CC BY-SA 3.0 TW +)', value: 'CC BY-SA', url: 'https://creativecommons.org/licenses/by-sa/3.0/tw/legalcode', image: '/assets/images/authority/cc-by-sa-70x25.webp', imageWidth: 70, imageHeight: 25},
  {label: '創用CC姓名標示-非商業性 3.0 台灣及其後版本(CC BY-NC 3.0 TW +)', value: 'CC BY-NC', url: 'https://creativecommons.org/licenses/by-nc/3.0/tw/legalcode', image: '/assets/images/authority/cc-by-nc-70x25.webp', imageWidth: 70, imageHeight: 25},
  {label: '創用CC姓名標示-非商業性-相同方式分享 3.0 台灣及其後版本(CC BY-NC-SA 3.0 TW +)', value: 'CC BY-NC-SA', url: 'https://creativecommons.org/licenses/by-nc-sa/3.0/tw/legalcode', image: '/assets/images/authority/cc-by-nc-sa-70x25.webp', imageWidth: 70, imageHeight: 25},
  {label: '創用CC姓名標示-禁止改作 3.0 台灣及其後版本(CC BY-ND 3.0 TW +)', value: 'CC BY-ND', url: 'https://creativecommons.org/licenses/by-nd/3.0/tw/legalcode', image: '/assets/images/authority/cc-by-nd-70x25.webp', imageWidth: 70, imageHeight: 25},
  {label: '創用CC姓名標示-非商業性-禁止改作 3.0 台灣及其後版本(CC BY-NC-ND 3.0 TW +)', value: 'CC BY-NC-ND', url: 'https://creativecommons.org/licenses/by-nc-nd/3.0/tw/legalcode', image: 'assets/images/authority/cc-by-nc-nd-70x25.webp', imageWidth: 70, imageHeight: 25},
  {label: '受著作權法保護-僅限於本平台有限度公開瀏覽', value: '僅限公開瀏覽', url: '', image: '/assets/images/authority/cc_icon7-25x25.webp', imageWidth: 25, imageHeight: 25},
  {label: '免申請、無償及非營利資料開放', value: '11', url: ''},
  {label: '資料尚待處理，僅做暫存', value: '12', url: ''},
];

export function transformAuthLicense(type: string) {
  const ret: any = {};
  const f = auths.find(auth => auth.value === type);
  return f;
}
